import { useModal } from '@/context/ModalContext';
import type { JiraImportDraft } from '@/components/modals/SelectCreateProjectFlowModal/JiraImport/sessionStorage';
import { JIRA_IMPORT_DETAILS_MODAL_ID } from '@/components/modals/JiraImportDetailsModal/constants';

interface JiraImportDetailsProps {
  jiraImport: JiraImportDraft;
}

export default function JiraImportDetails({
  jiraImport,
}: JiraImportDetailsProps) {
  const { openModal } = useModal();

  return (
    <button
      type="button"
      onClick={() => openModal(JIRA_IMPORT_DETAILS_MODAL_ID, { jiraImport })}
      className="ml-2 text-sm font-semibold text-text-primary-heading underline underline-offset-4 transition-opacity hover:opacity-70"
    >
      View
    </button>
  );
}
